import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import EditorBase from "../../../bryntum-lib/editors/base/EditorBase.jsx";
import {ViewStateInspectionView} from "../../../other/feature/views/widget/ViewStateInspectionView.jsx";

export class SwivuViewStateInspectionPopup extends EditorBase {
  static get $name() {
    return "SwivuViewStateInspectionPopup";
  }

  static get type() {
    return WIDGET_KEYS.swivuViewStateInspectionPopup;
  }

  static get configurable() {
    return {
      minWidth: "300px",
      width: "300px",
      closable: false,
      autoClose: true,
      scrollable: false,
      draggable: false,
      anchor: true,
      floating: true,
      header: false,
      scrollAction: "hide",
      autoShow: false,
      centered: false,
      contentElementCls: "p-[0.2em]",
      items: {
        viewInspection: {
          type: ViewStateInspectionView.type
        }
      }
    }
  }

  editRecord(record, context, otherParams) {
    super.editRecord(record, context, otherParams);

    const { viewInspection } = this.widgetMap;

    viewInspection.loadRecord(record, context, otherParams);
  }
}

SwivuViewStateInspectionPopup.initClass();